import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useAuth();
  const nav = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      // The login function now returns user data
      const userData = await login(username, password);
      // Redirect to user's "My Grades" page using their ID
      nav(`/users/${userData.id}`);
    } catch (e) {
      console.log(e);
      setError('Invalid credentials');
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} style={{ maxWidth: 300, margin: '2rem auto' }}>
      <h2>Login</h2>
      {error && <p style={{color:'red'}}>{error}</p>}
      <div>
        <label>Username</label><br/>
        <input 
          value={username} 
          onChange={e=>setUsername(e.target.value)} 
          required 
          disabled={loading}
        />
      </div>
      <div>
        <label>Password</label><br/>
        <input 
          type="password" 
          value={password} 
          onChange={e=>setPassword(e.target.value)} 
          required
          disabled={loading}
        />
      </div>
      <button type="submit" disabled={loading}>
        {loading ? 'Logging in...' : 'Login'}
      </button>
      <p>
        Don't have an account? <Link to="/register">Register</Link>
      </p>
    </form>
  );
}